export default "__VITE_ASSET__BayeAdpo__"